import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = "/unranked";

// ---------------- ADD ----------------
export const addUnranked = createAsyncThunk(
  "unranked/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, data);
      toast.success("تم إضافة العنصر بنجاح");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- GET ALL ----------------
export const getUnranked = createAsyncThunk(
  "unranked/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);
      if (params.search) query.append("search", params.search);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching unranked items:", error.response?.error);
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- UPDATE ----------------
export const updateUnranked = createAsyncThunk(
  "unranked/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, data);
      toast.success("تم التحديث بنجاح");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- TOGGLE ACTIVE ----------------
export const toggleUnranked = createAsyncThunk(
  "unranked/toggle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `${API_URL}/toggle-active/${id}`,
      );
      toast.success("تم تغيير الحالة");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- DELETE ----------------
export const deleteUnranked = createAsyncThunk(
  "unranked/delete",
  async ({ id }, { rejectWithValue }) => {
    // console.log("Deleting unranked item with ID:", id);
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);
      toast.success("تم الحذف");
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
